import { SUBSCRIPTION_STATUS } from '@wetransfer/transfer/store/types';

export const ACTIVE_STATUSES = [
  SUBSCRIPTION_STATUS.active,
  SUBSCRIPTION_STATUS.past_due,
  SUBSCRIPTION_STATUS.trialing,
  SUBSCRIPTION_STATUS.unpaid,
];

//These values should just be used for promoting plans
//Anything specific to the user should come from user.rules
export const FREE = {
  TRANSFER_LIMIT: '2 GB',
};

export const FREE_ACCOUNT = {
  TRANSFER_LIMIT: '2 GB',
  STORAGE_LIMIT: '1 TB',
};

export const PLUS_ACCOUNT = {
  STORAGE_LIMIT: '1 TB',
  PORTALS_LIMIT: 1,
};

export const PREMIUM_ACCOUNT = {
  STORAGE_LIMIT: '5 TB',
  ANNUAL_STORAGE_LIMIT: '15 TB',
};

export const getTeamStorageLimit = (memberCount = 1): string => {
  const baseStoragePerUser = 1;

  return `${baseStoragePerUser * memberCount} TB`;
};
